import { useState } from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';

const useElementScrollPosition = (scrollElementRef) => {
  const [scrolledElementPosition, setScrolledElementPosition] = useState({
    x: 0,
    y: 0,
    scrolledY: 0,
    scrolledP: 0,
  });

  useScrollPosition(
    ({ currPos }) => {
      if (!scrollElementRef.current) {
        return;
      }

      const scrolledY = -currPos.y;
      const scrolledP =
        scrolledY /
        (scrollElementRef.current.clientHeight - window.innerHeight);

      setScrolledElementPosition({
        ...currPos,
        scrolledY,
        scrolledP,
      });
    },
    [],
    scrollElementRef
  );

  return scrolledElementPosition;
};

export default useElementScrollPosition;
